// rows.ts
export interface RowDataGuide {
    id: number;
    NAME: string;
    OFFICE: string;
    LASTTIME: string;
    CATEGORY: string;
    IS_ACTIVE: boolean;
  }

  export interface RowDataPlan {
    id: number;
    NAME: string;
    GOAL: string;
    AUTOMATIC_CALL_SNACK: string;
    IS_ACTIVE: boolean;
  }

  export interface RowDataNursingIntervention {
    id: number;
    NAME: string;
    NOTE: string;
    DIABET: string;
    VEGAN : string;
    HYPERTENSION: string;
    HALAL: string;
    LAST_REQUEST_TIME: string;
    LASTTIME: string;
    IS_ACTIVE: boolean;
  }

  export const rowsGuide: RowDataGuide[] = [
    {
      id: 1,
      OFFICE: "Yazılım Test Hastanesi",
      NAME:"Sabah",
      LASTTIME: "08:00",
      CATEGORY:"Sabah",
      IS_ACTIVE: true,
    },
    {
      id: 2,
      OFFICE: "Yazılım Test Hastanesi",
      NAME:"Öğlen",
      LASTTIME: "10:00",
      CATEGORY:"Öğle",
      IS_ACTIVE: false,
    },
    {
      id: 3,
      OFFICE: "Yazılım Test Hastanesi",
      NAME:"Gece",
      LASTTIME: "12:00",
      CATEGORY:"Gece",
      IS_ACTIVE: true,
    },
    {
      id: 4,
      OFFICE: "Yazılım Test Hastanesi",
      NAME:"Akşam",
      LASTTIME: "12:00",
      CATEGORY:"Gece",
      IS_ACTIVE: true,
    },
  ];

  export const rowsPlan: RowDataPlan[] = [
    {
      id: 4,
      NAME: "Normal",
      GOAL: "",
      AUTOMATIC_CALL_SNACK: "Coumadin",
      IS_ACTIVE: false,
    },
    {
      id: 5,
      NAME: "Diyet",
      GOAL: "",
      AUTOMATIC_CALL_SNACK:"",
      IS_ACTIVE: true,
    },
    {
      id: 6,
      NAME: "Ara Öğün",
      GOAL: "",
      AUTOMATIC_CALL_SNACK:"",
      IS_ACTIVE: true,
    },
  ];

  export const rowsNursingIntervention: RowDataNursingIntervention[] = [
    {
      id: 1,
      NAME: "Normal",
      NOTE:"",
      DIABET: "12 Saat",
      VEGAN : "",
      HYPERTENSION: "",
      HALAL: "",
      LAST_REQUEST_TIME: "16:00",
      LASTTIME: "09:00",
      IS_ACTIVE: false,
    },
    {
      id: 2,
      NAME: "Sulu Yemek",
      NOTE:"",
      DIABET: "6 Saat",
      VEGAN : "",
      HYPERTENSION: "",
      HALAL: "",
      LAST_REQUEST_TIME: "16:00",
      LASTTIME: "15:00",
      IS_ACTIVE: true,
    },
    {
      id: 3,
      NAME: "Yemek",
      NOTE:"",
      DIABET: "24 Saat",
      VEGAN : "",
      HYPERTENSION: "",
      HALAL: "",
      LAST_REQUEST_TIME: "16:00",
      LASTTIME: "18:00",
      IS_ACTIVE: true,
    },
  ];